import { ascend, descend, prop, sortWith } from 'ramda'

import { formatProductSize, isBlank } from 'utils'
import wrapArray from 'utils/wrapArray'

const filterWith = (fn) => (arr) => fn ? arr.filter(fn) : arr

const filterByInstock = (value) => {
  if (value === false) return null

  return ({ size_variants, total_inventory_quantity, tracks_inventory }) => {
    if (!tracks_inventory) return true
    if (isBlank(size_variants)) return total_inventory_quantity > 0
    return size_variants.find(({ inventory_quantity }) => inventory_quantity > 0)
  }
}

const filterBySize = (values) => {
  if (isBlank(values)) return null

  return ({ size_variants }) => {
    return (size_variants || []).some(({ size }) => wrapArray(values).includes(formatProductSize(size)))
  }
}

const filterBySizeAndInstock = (values) => {
  if (isBlank(values)) return null

  return ({ size_variants }) => {
    return (size_variants || []).some(
      ({ size, inventory_quantity }) => wrapArray(values).includes(formatProductSize(size)) && inventory_quantity > 0
    )
  }
}

const filterByArtisan = (values) => {
  if (isBlank(values)) return null

  return ({ vendor }) => wrapArray(values).includes(vendor)
}

const filterByCategory = (values) => {
  if (isBlank(values)) return null

  return ({ category }) => wrapArray(values).includes(category)
}

const filterByColor = (values) => {
  if (isBlank(values)) return null

  return ({ options }) => wrapArray(values).includes(options?.color)
}

const filterByModel = (values) => {
  if (isBlank(values)) return null

  return ({ named_tags }) => wrapArray(values).includes(named_tags?.model)
}

const filterByPrice = (value) => {
  if (isBlank(value)) return null

  const [min, max] = value

  return ({ variants_min_price, variants_max_price }) => variants_min_price >= min && variants_max_price <= max
}

const sorts = {
  'title|desc': sortWith([descend(prop('title'))]),
  'title|asc': sortWith([ascend(prop('title'))]),
  'price|desc': sortWith([descend(prop('price'))]),
  'price|asc': sortWith([ascend(prop('price'))]),
  'published_at|desc': sortWith([descend(prop('published_at'))]),
  'published_at|asc': sortWith([ascend(prop('published_at'))]),
}

const sort = (sortBy, products) => {
  if (!sortBy || sortBy === 'manual') return products

  return sorts[sortBy](products)
}

export const filterProducts = ({ products, state }) => {
  let filteredProducts = [...products]

  // In-stock only
  filteredProducts = filterWith(filterByInstock(state.instock))(filteredProducts)

  // Shop by Size
  const filterBySizeAndInstockResolved = state.instock ? filterBySizeAndInstock : filterBySize
  filteredProducts = filterWith(filterBySizeAndInstockResolved(state.size))(filteredProducts)

  // Artisan
  filteredProducts = filterWith(filterByArtisan(state.artisan))(filteredProducts)

  // Category
  filteredProducts = filterWith(filterByCategory(state.category))(filteredProducts)

  // Color
  filteredProducts = filterWith(filterByColor(state.color))(filteredProducts)

  // Model
  filteredProducts = filterWith(filterByModel(state.model))(filteredProducts)

  // Price
  filteredProducts = filterWith(filterByPrice(state.price))(filteredProducts)

  filteredProducts = sort(state.sortBy, filteredProducts)

  return filteredProducts
}
